var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1592 7.94727H28.4611V15.0725H25.1592V7.94727Z",
    fill: "#F2CA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1592 7.94727H28.4611V15.0725H25.1592V7.94727Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4688 18.9891L31.5582 21.1061L29.7655 19.488L18 8.87731L6.23447 19.488L4.44178 21.1061L2.53125 18.9891L18 5.03516L33.4688 18.9891Z",
    fill: "#737AE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7654 19.4877V30.9644H6.23438V19.4877L17.9999 8.87695L29.7654 19.4877Z",
    fill: "#F2CA52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7654 19.4877V30.9644H6.23438V19.4877L17.9999 8.87695L29.7654 19.4877Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7664 19.4867V21.269L18.0009 10.6583L6.23535 21.269V19.4867L18.0009 8.87598L29.7664 19.4867Z",
    fill: "#F2CA52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7664 19.4867V21.269L18.0009 10.6583L6.23535 21.269V19.4867L18.0009 8.87598L29.7664 19.4867Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.4258C17.5344 21.4258 17.0734 21.5175 16.6432 21.6957C16.213 21.8739 15.8222 22.1351 15.4929 22.4643C15.1637 22.7936 14.9025 23.1844 14.7244 23.6146C14.5462 24.0448 14.4546 24.5059 14.4546 24.9715V30.9658H21.5455V24.9715C21.5455 24.5059 21.4538 24.0448 21.2757 23.6146C21.0975 23.1844 20.8364 22.7936 20.5071 22.4643C20.1779 22.1351 19.787 21.8739 19.3569 21.6957C18.9267 21.5175 18.4656 21.4258 18 21.4258Z",
    fill: "#636799"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0976 6.96777H24.5233C24.3869 6.96777 24.2764 7.07833 24.2764 7.21471V8.91065C24.2764 9.04703 24.3869 9.15759 24.5233 9.15759H29.0976C29.2339 9.15759 29.3445 9.04703 29.3445 8.91065V7.21471C29.3445 7.07833 29.2339 6.96777 29.0976 6.96777Z",
    fill: "#F2CA52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0976 6.96777H24.5233C24.3869 6.96777 24.2764 7.07833 24.2764 7.21471V8.91065C24.2764 9.04703 24.3869 9.15759 24.5233 9.15759H29.0976C29.2339 9.15759 29.3445 9.04703 29.3445 8.91065V7.21471C29.3445 7.07833 29.2339 6.96777 29.0976 6.96777Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b82a5fce25a9dc1626697c26ddb3ba66.svg";
export { ForwardRef as ReactComponent };